import tv from '~/lib/tv'

export type CardProps = {
  as?: React.ElementType
  header?: React.ReactNode
  footer?: React.ReactNode
  href?: HTMLDivElement | null
  children: React.ReactNode
  color?: 'primary' | 'secondary'
  border?: boolean
  size?: 'full'
  className?: string
  onClick?: () => void
}

const cardVariants = tv({
  base: 'flex flex-col justify-items-stretch rounded-lg p-4 gap-4 mx-auto w-full',
  variants: {
    color: {
      primary: 'bg-white',
      secondary: 'bg-gray-10',
    },
    border: {
      true: 'border border-gray-20',
    },
    size: {
      full: 'w-full',
    },
  },
})

export default function Card({
  as: Component = 'div',
  header,
  footer,
  href = null,
  children,
  color,
  border,
  size,
  className,
  ...props
}: CardProps) {
  return (
    <Component {...props} className={cardVariants({ color, border, size, className })} href={href}>
      {header && <header>{header}</header>}
      {children}
      {footer && <footer>{footer}</footer>}
    </Component>
  )
}
